var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('div',{staticClass:"row row-left"},[_c('h4',{staticClass:"title__medium"},[_vm._v(" "+_vm._s(_vm.title))])]),_c('div',{staticClass:"slot-wrapper"},[_vm._t("right")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }